export const ListViewType = {
  /** 行模式 */
  Row: 1,
  /** 卡片模式 */
  Card: 2,
};
